import type { FC } from 'react';

import { DynamicImage } from '@wwe-portal/ui/components/dynamic-image';
import { cn } from '@wwe-portal/ui/lib/lib';

import type { OfferItem as OfferItemType } from '../type';

import { StarRarity } from './star-rarity';

export const OfferItemsRevamp: FC<{
  maxItem: number;
  items?: OfferItemType[];
  totalItems?: number;
  isHiddenQuantity?: boolean;
  description: string | undefined;
}> = ({
  items,
  maxItem,
  isHiddenQuantity = false,
  description,
  totalItems,
}) => {
  if (items == null || items.length === 0) return null;
  const renderedItems = items.slice(0, maxItem);
  const itemLen = items.length;

  return (
    <div className="absolute inset-0 flex items-center justify-start gap-5 overflow-hidden stroke-2 font-semibold text-white">
      <div
        className={cn(
          'ml-13 h-full max-w-[calc(15200%/348)] flex-1 overflow-auto'
        )}
      >
        {description?.trim() && (
          <div className="font-poppins text-goldtier text-2xs inline-block bg-[#000000] bg-opacity-65 p-1">
            {description}
          </div>
        )}
      </div>
      <div
        className={cn(
          'flex flex-1 items-center justify-evenly gap-5 self-stretch',
          {
            'justify-start': items.length === 1,
          }
        )}
      >
        {renderedItems.map((item) => {
          const isMore = item.text?.includes('MORE') && totalItems != null;
          return (
            <div
              className="flex h-full shrink-0 grow-0 flex-col items-center justify-end gap-1.5"
              data-id={item.itemId}
              key={item.itemId}
              style={{
                width: 56,
              }}
            >
              <div className="relative h-0 w-full shrink-0 grow">
                <DynamicImage
                  alt={item.itemId}
                  className="h-full w-full object-contain object-bottom"
                  defaultUrl={item.defaultImageUrl}
                  dynamicUrl={item.dynamicImageUrl}
                  resizedWidth={64}
                />
                <StarRarity item={item} />
              </div>
              <div
                className={cn(
                  'h-[calc(1200%/58)] shrink-0 grow-0 text-xs capitalize leading-none',
                  {
                    hidden: isHiddenQuantity,
                    'whitespace-nowrap break-keep lowercase': isMore,
                  }
                )}
              >
                {isMore
                  ? `+${totalItems - itemLen} more`
                  : item.text ||
                    (item.quantity && (
                      <span>{item.text ?? item.quantity}</span>
                    ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
